import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  MdDashboard, 
  MdBadge, 
  MdPeople, 
  MdSettings,
  MdClose 
} from 'react-icons/md';
import { canManageUsers } from '../../utils/auth';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const canManageUsersPermission = canManageUsers();

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const handleLinkClick = () => {
    // Close sidebar when a link is clicked on mobile
    if (window.innerWidth <= 768) {
      onClose();
    }
  };

  return (
    <nav className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <button className="sidebar-close" onClick={onClose}>
          <MdClose />
        </button>
      </div>
      <ul className="sidebar-menu">
        <li>
          <Link 
            to="/dashboard" 
            className={`menu-item ${isActive('/dashboard')}`}
            onClick={handleLinkClick}
          >
            <span className="menu-icon"><MdDashboard /></span>
            Dashboard
          </Link>
        </li>
        
        <li>
          <Link 
            to="/digital-cards" 
            className={`menu-item ${isActive('/digital-cards')}`}
            onClick={handleLinkClick}
          >
            <span className="menu-icon"><MdBadge /></span>
            Digital Cards
          </Link>
        </li>
        
        {canManageUsersPermission && (
          <li>
            <Link 
              to="/users" 
              className={`menu-item ${isActive('/users')}`}
              onClick={handleLinkClick}
            >
              <span className="menu-icon"><MdPeople /></span>
              User Management
            </Link>
          </li>
        )}
        
        <li>
          <Link 
            to="/settings" 
            className={`menu-item ${isActive('/settings')}`}
            onClick={handleLinkClick}
          >
            <span className="menu-icon"><MdSettings /></span>
            Settings
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Sidebar;
